// extracted by mini-css-extract-plugin
var _1 = "CarouselControls-module__animatedBackground--t4w9m";
var _2 = "CarouselControls-module__button--zEOUu";
var _3 = "CarouselControls-module__container--zwu0G";
var _4 = "CarouselControls-module__left--Z4MjR";
var _5 = "CarouselControls-module__pagination--lPLlB";
var _6 = "CarouselControls-module__right--VMEa2";
export { _1 as "animatedBackground", _2 as "button", _3 as "container", _4 as "left", _5 as "pagination", _6 as "right" }
